import React from 'react'
import { useNavigate } from 'react-router-dom'
import FunctionsIcon from '@mui/icons-material/Functions';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import UploadOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
export default function MentorOptions() {
    const navigate = useNavigate()

    return (

        <>
            <h1 className='text-center text-primary m-2'>Mentor Options</h1>
            <h4 className='text-center text-primary m-1'>Management</h4>
            <div className='d-flex justify-content-center w-100 m-2'>
                <div className="list-group w-50">
                <a style={{ "cursor": "pointer" ,minWidth:"220px"}} onClick={() => navigate('/mentor/list')} className="list-group-item list-group-item-action "><ArticleOutlinedIcon fontSize='large'></ArticleOutlinedIcon> Mentee List</a>
                </div>
            </div>
        </>
    )
}